<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item active" aria-current="page">
				<fa-icon [icon]="ac.sectionIcons.quizzes" class="cp-user-nav-item me-1" size="sm">
				</fa-icon>
				Quizzes + Polls
			</li>
		</ol>
	</nav>

	<div class="actions">
		<div class="form-inline">
			<button type="button" class="btn btn-outline-secondary" (click)="loadData()" [disabled]="loading">
				<fa-icon icon="sync-alt" size="sm" [spin]="loading" ngbTooltip="Refresh" placement="start"></fa-icon>
			</button>
		</div>
	</div>
</div>

<button (click)="ut.scrollToSpot('top-of-list')" id="top-of-list-button" class="cp-scroll-to-top-end d-none" title="Go to top">
	<fa-icon [icon]="['fas', 'angle-up']"></fa-icon>Top
</button>
<div class="list-wrapper" id="list-page-id" (scroll)="ut.onDivScrollHandler('top-of-list-button', 'list-page-id')">
	<div id="top-of-list"></div>

	<div *ngIf="loading" style="text-align: center;">
		<app-loading-spinner></app-loading-spinner>
	</div>

	<div *ngIf="!loading && quizzesToShow.length === 0" class="cp-warning-message">
		<fa-icon [icon]="['fas', 'exclamation-triangle']" size="sm"></fa-icon>
		There aren't any quizzes or polls for you to see.
	</div>

	<ul *ngIf="quizzesToShow && quizzesToShow.length !== 0">
		<li *ngFor="let item of quizzesToShow">
			<a [routerLink]="[item.id]">{{ item.name }}</a>
			({{ mt.fetchLabel(ac.quizStatusSelections, item.status, 'value', 'shortLabel') }}
			/ {{ mt.fetchLabel(ac.quizTypeSelections, item.config.quizType, 'value', 'shortLabel') }})
		</li>
	</ul>
</div>